export default [
  {
    path: "/inXiaMen", //走进厦门
    name: "inXiaMen",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/inXiaMen.vue")
  },
  {
    path: "/investmentXm", //投资厦门
    name: "investmentXm",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/investmentXm.vue")
  },
  {
    path: "/InvestmentPlatform2", //招商平台
    name: "InvestmentPlatform2",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/InvestmentPlatform2.vue")
  },
  {
    path: "/investmentOpportunities2", //投资机会清单
    name: "investmentOpportunities2",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/investmentOpportunities2.vue")
  },
  {
    path: "/policyExpress", //政策速递
    name: "policyExpress",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/policyExpress.vue")
  },
  {
    path: "/xiamenTalent", //厦门人才
    name: "xiamenTalent",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/xiamenTalent.vue")
  },
  {
    path: "/investmentService", //投资服务
    name: "investmentService",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/investmentService.vue")
  },
  {
    path: "/investmentMap", //招商地图
    name: "investmentMap",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/investmentMap.vue")
  },
  {
    path: "/endorseDetail", //深情代言
    name: "endorseDetail",
    component: () =>
      import("@/view/CloudFair/Government/secondPage/xm/detailPage/endorseDetail.vue")
  }
];



// WEBPACK FOOTER //
// ./src/router/cloudFair/xm.js